// SYNC WITH CSS MEDIA QUERIES
// ----------------------------------------------------------------------------
function screenSizeIsBiggerThan(bp) {
  function getComputedContent(attr) {
    var elem = document.querySelector('body');

    return window.getComputedStyle( elem, attr)
      .getPropertyValue('content').replace(/\"|\'/g, '');
  }

  function getBreakPointsStatus() {
    var status = {};
    var breakpointList = getComputedContent(':after');
    var arr = breakpointList.split(',');

    for(var i = 0; i < arr.length; i ++) {
      status[arr[i]] = false;
    }

    return status;
  }

  var actualBreakpoint = getComputedContent(':before');
  var context = getBreakPointsStatus();

  for (var k in context) {
    context[k] = true;
    if(k === actualBreakpoint) { break; }
  }

  return context[bp];
}

// Drop down navigation
(function () {
  var $dropdowns = $('[data-dropdown="wrap"]');

  var hideDropdown = function(el, panel) {
    var $element = $(el),
        $panel = $(panel);

    if( $element.data('dropdown-mobile') === 'off' && !screenSizeIsBiggerThan('M') ) {
      return false;
    }

    $element.removeClass('is-expanded');

    if( screenSizeIsBiggerThan('M') ) {
      $panel.hide();
    } else {
      $panel.slideUp('fast');
    }
  };

  var hideAllDropdowns = function() {
    $dropdowns.each(function() {
      var $self = $(this),
          $panel = $self.find('[data-dropdown="panel"]');

      hideDropdown($self, $panel);
    });
  };

  var showDropdown = function(el, panel) {
    var $element = $(el),
        $panel = $(panel);

    hideAllDropdowns();

    $element.addClass('is-expanded');
    if( screenSizeIsBiggerThan('M') ) {
      $panel.show();
    } else {
      $panel.slideDown('fast');
    }
  };


  $.fn.dropdown = function() {
    return this.each(function() {
      var $self = $(this);

      if( $self.data('dropdown-mobile') === 'off' && !screenSizeIsBiggerThan('M') ) {
        return false;
      }

      var $trigger = $self.find('[data-dropdown="trigger"]'),
          triggerEvent = $trigger.data('desktop-event'),
          $panel = $self.find('[data-dropdown="panel"]');

      var bindEvents = function() {
        if( screenSizeIsBiggerThan('M') && triggerEvent === 'hover' ) {
          $self.on('mouseenter', function() {
            showDropdown($self, $panel);
          });

          $self.on('mouseleave', function() {
            hideDropdown($self, $panel);
          });
        } else {
          $trigger.on('click', function(e) {
            if ($self.hasClass('is-expanded')) {
              hideDropdown($self, $panel);
            } else {
              showDropdown($self, $panel);
            }
            e.preventDefault();
          });
        }
      };

      var init = function() {
        bindEvents();
      };

      init();
    });
  };


  hideAllDropdowns();
  $dropdowns.dropdown();

}());
